import { contato, destaques, linkWhatsApp } from '../data/conteudo';
import { IconeWhatsApp } from './Icones';
import foto from '../images/ana-caroline.jpg';
import mandala from '../images/mandala.png';
import styles from './Inicio.module.css';

const Inicio = () => (
  <section id="inicio" className={styles.inicio} aria-labelledby="titulo-inicio">
    <div className={`container ${styles.grade}`}>
      <div className={styles.texto}>
        <h1 id="titulo-inicio" className={styles.titulo}>
          Um espaço seguro para cuidar de você, onde você estiver.
        </h1>
        <p className={styles.apresentacao}>
          Sou {contato.nome}, {contato.titulo.toLowerCase()} ({contato.crp}). Atendo adolescentes e
          adultos na modalidade online, com escuta atenta, ética e sigilo.
        </p>
        <div className={styles.acoes}>
          <a className="botao botao-principal" href={linkWhatsApp} target="_blank" rel="noopener noreferrer">
            <IconeWhatsApp />
            Agendar pelo WhatsApp
          </a>
          <a className="botao botao-secundario" href="#especialidades">
            Ver especialidades
          </a>
        </div>
      </div>

      <figure className={styles.retrato}>
        <img className={styles.mandala} src={mandala} alt="" aria-hidden="true" />
        <div className={styles.arco}>
          <img src={foto} alt={`Foto de ${contato.nome}`} width={268} height={263} />
        </div>
        <figcaption className={styles.legenda}>
          <strong>{contato.nome}</strong>
          <span>{contato.crp}</span>
        </figcaption>
      </figure>
    </div>

    <div className="container">
      <ul className={styles.destaques}>
        {destaques.map((item) => (
          <li key={item}>{item}</li>
        ))}
      </ul>
    </div>
  </section>
);

export default Inicio;
